module.exports = __webpack_public_path__ + "static/media/nFocusLogoBar.c127cedd.svg";